import { render, staticRenderFns } from "./UserMgEditDialog.vue?vue&type=template&id=2c4aebe7&scoped=true&"
import script from "./UserMgEditDialog.vue?vue&type=script&lang=js&"
export * from "./UserMgEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4aebe7",
  null
  
)

export default component.exports